import { AvvirEvent } from "type_aliases";
import PlannedBuildingElement from "../../models/domain/planned_building_element";

export type ReviztoIssueCreationDialogShownEvent = AvvirEvent<typeof REVIZTO_ISSUE_CREATION_DIALOG_SHOWN, {  globalId: string,selectedElements: PlannedBuildingElement[] }>

const reviztoIssueCreationDialogShown = ( globalId: string,selectedElements: PlannedBuildingElement[]): ReviztoIssueCreationDialogShownEvent => ({
  type: REVIZTO_ISSUE_CREATION_DIALOG_SHOWN,
  payload: {
    globalId: globalId,
    selectedElements: selectedElements,
  }
});

export const REVIZTO_ISSUE_CREATION_DIALOG_SHOWN = "revizto_issue_creation_dialog_shown";

export default reviztoIssueCreationDialogShown;
